export default "__VITE_ASSET__CINh1IaX__"